import React from 'react';
import PropTypes from 'prop-types';
import { Modal as MaterialModal, Box, Icon, IconButton } from '@material-ui/core';
import { CloseSmallIcon } from '../Icons';

const Modal = ({ children, isOpen, onClose, classes, closeButton, closeIconSize, disablePortal }) => {
  const closeIconStyle = closeButton === 'right' ? classes.rightCloseIconButton : classes.closeIconButton;
  const closeIconType = closeIconSize === 'big' ? classes.closeIconBig : classes.closeIcon;

  return (
    <MaterialModal open={isOpen} onClose={onClose} disablePortal={disablePortal} data-testid="modal">
      <Box className={classes.modalContainer}>
        <IconButton onClick={onClose} className={closeIconStyle} data-testid="modal-close-button">
          <Icon component={CloseSmallIcon} className={closeIconType} />
        </IconButton>
        {children}
      </Box>
    </MaterialModal>
  );
};

Modal.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  closeButton: PropTypes.oneOf(['left', 'right']),
  closeIconSize: PropTypes.string,
  disablePortal: PropTypes.bool,
};

Modal.defaultProps = {
  classes: {},
  isOpen: false,
  onClose: () => {},
  closeButton: 'left',
  disablePortal: false,
};

export default Modal;
